import React from 'react';
import { Link as RouterLink, Navigate } from 'react-router-dom';
import {DisputePolicy as DisputePolicyComponent} from '../../components'

import {
  Typography,
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@mui/material';
import useClasses from '../../helpers/useClasses';

const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  sugestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  },
  list: {
    paddingLeft: theme.spacing(3)
  }
});

const DisputeProcess  = (props) => {
  const classes = useClasses(styles);

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Card>
          <CardContent className={classes.terms}>
          <DisputePolicyComponent />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default DisputeProcess;
